export default __webpack_public_path__ + "static/media/Home.dbc0f076.svg";